import { render, staticRenderFns } from "./salaryTemplate-list.vue?vue&type=template&id=23e41fbb&scoped=true&"
import script from "./salaryTemplate-list.vue?vue&type=script&lang=js&"
export * from "./salaryTemplate-list.vue?vue&type=script&lang=js&"
import style0 from "./salaryTemplate-list.vue?vue&type=style&index=0&id=23e41fbb&scoped=scoped&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23e41fbb",
  null
  
)

export default component.exports